import React from 'react';
import classnames from 'classnames';
import * as styles from './Filter.scss';
import GeoSearch from '../GeoSearch';
import CheckSelect from '../CheckSelect';
import { groupIds } from '../../constants/uiParams';
import {
  AtiDocIcon,
  AutoparkIcon,
  ConfirmedContactsIcon,
  OrdersIcon,
  VerifiedProfileIcon,
  EpdMedalIcon,
} from '../FilterIcons';

const Filter = (props) => {
  const {
    verified,
    autopark,
    atiOrders,
    atiDocs,
    confirmedContacts,
    epdMedal,
    handleVerifiedClick,
    handleAutoparkClick,
    handleAtiOrdersClick,
    handleAtiDocsClick,
    handleConfirmedContactsClick,
    handleEpdMedalClick,
    firmTypeAbbreviation,
    selectedGroupId,
  } = props;

  return (
    <div
      className={classnames(styles.filter, { [styles._firstSelected]: selectedGroupId === groupIds.Carrier })}
    >
      <div className={classnames(styles.filterRow, styles.filterRow__first)}>
        <GeoSearch />
        <CheckSelect />
      </div>
      <div className={classnames(styles.filterRow, styles.filterRow__second)}>
        <VerifiedProfileIcon
          firmTypeAbbreviation={firmTypeAbbreviation}
          verified={verified}
          handleVerifiedClick={handleVerifiedClick}
        />
        <AutoparkIcon
          autopark={autopark}
          handleAutoparkClick={handleAutoparkClick}
        />
        <OrdersIcon
          atiOrders={atiOrders}
          handleAtiOrdersClick={handleAtiOrdersClick}
        />
        <AtiDocIcon
          atiDocs={atiDocs}
          handleAtiDocsClick={handleAtiDocsClick}
        />
        <ConfirmedContactsIcon
          confirmedContacts={confirmedContacts}
          handleConfirmedContactsClick={handleConfirmedContactsClick}
        />
        <EpdMedalIcon
          epdMedal={epdMedal}
          handleEpdMedalClick={handleEpdMedalClick}
        />
      </div>
    </div>
  );
};

export default Filter;
